"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchActive = exports.update = exports.create = void 0;
const Api = require("../../Api");
const actions = require("./actions");
const create = (dispatch) => {
    return async (name) => {
        dispatch(actions.createRequest(name));
        try {
            const { data: { workspace } } = await Api.client.post('/workspaces', { item: { name } });
            dispatch(actions.createSuccess(workspace));
        }
        catch (error) {
            dispatch(actions.createFailure(Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.create = create;
const update = (dispatch) => {
    return async (workspaceId, attributes) => {
        dispatch(actions.updateRequest(workspaceId, attributes));
        try {
            const { data: { workspace } } = await Api.client.put(`/workspaces/${workspaceId}`, { item: attributes });
            dispatch(actions.updateSuccess(workspaceId, workspace));
        }
        catch (error) {
            dispatch(actions.updateFailure(Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.update = update;
const switchActive = (dispatch) => {
    return async (workspaceId) => {
        dispatch(actions.switchActive(workspaceId));
        await Api.setUpWorkspace(workspaceId);
        return true;
    };
};
exports.switchActive = switchActive;
//# sourceMappingURL=operations.js.map